export function isTokenAddressEquivalent({
  firstTokenAddress,
  secondTokenAddress,
}: { firstTokenAddress: string; secondTokenAddress: string }) {
  return (
    String(firstTokenAddress).toLowerCase() ===
    String(secondTokenAddress).toLowerCase()
  )
}

export function isTokenEquivalent({
  firstTokenChainId,
  firstTokenAddress,
  secondTokenChainId,
  secondTokenAddress,
}: {
  firstTokenChainId: string
  firstTokenAddress: string
  secondTokenChainId: string
  secondTokenAddress: string
}) {
  return (
    String(firstTokenChainId) === String(secondTokenChainId) &&
    isTokenAddressEquivalent({ firstTokenAddress, secondTokenAddress })
  )
}
